/* eslint-disable react/forbid-prop-types */
import React from "react";
import PropTypes from "prop-types";
import Rating from "react-rating";
import LevelComponent from "./LevelComponent";
import FilledStar from "../assets/icons/filledStar.svg";
import EmptyStar from "../assets/icons/emptyStar.svg";

export default function ReviewInsightsCard({ data }) {
  return (
    <div>
      <div className="border rounded-xl px-4 py-4">
        <div className="text-center mb-4">
          <p className="text-2xl md:text-3xl font-semibold">
            {data?.average_rating}
          </p>
          <Rating
            start={0}
            stop={5}
            step={1}
            readonly
            initialRating={data?.average_rating}
            fullSymbol={
              <img src={FilledStar} className="icon" alt="filled star" />
            }
            emptySymbol={
              <img src={EmptyStar} className="icon" alt="empty star" />
            }
          />
          <p className="text-[#848792]">
            Based on {data?.review_total} reviews
          </p>
        </div>

        <div className="space-y-2">
          <LevelComponent
            label="Excellent"
            total={data?.review_total}
            value={data?.five_star_reviews}
            levelClassName="h-full bg-[#4BA34B] rounded-xl"
          />

          <LevelComponent
            label="Good"
            total={data?.review_total}
            value={data?.four_star_reviews}
            levelClassName="h-full bg-[#A5D633] rounded-xl"
          />

          <LevelComponent
            label="Average"
            total={data?.review_total}
            value={data?.three_star_reviews}
            levelClassName="h-full bg-[#F6E632] rounded-xl"
          />

          <LevelComponent
            label="Fair"
            total={data?.review_total}
            value={data?.two_star_reviews}
            levelClassName="h-full bg-[#F6A521] rounded-xl"
          />

          <LevelComponent
            label="Poor"
            total={data?.review_total}
            value={data?.one_star_reviews}
            levelClassName="h-full bg-[#EE3A10] rounded-xl"
          />
        </div>
      </div>
    </div>
  );
}

ReviewInsightsCard.propTypes = {
  data: PropTypes.object.isRequired,
};
